<template>
  <div class="box">
    <div class="headerContentbox">
      <div class="iconBox"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Header",
  props: ["hideTable", "clockButtonFlags"],
  data() {
    return {
      activeIndex2: "",
    };
  },
  mounted() {
    // this.initChart();
  },
  watch: {
    clockButtonFlags(newVal, oldVal) {
      this.activeIndex2 = newVal;
    },
  },
  methods: {
    handleSelect(v) {
      console.log(12122, v);
      if (document.getElementById(v)) {
        document.getElementById(v).scrollIntoView();
        console.log("结束");
        return;
      }
      this.$emit("hideTableFun", v);
    },
  },
};
</script>

<style scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.headerContentbox {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
  background: #fff;
  overflow: hidden;
}
.iconBox {
  float: left;
  width: 163px;
  height: 50px;
  margin-top: 15px;
  background: url("../assets/logoIcon.png") no-repeat center center;
  background-size: 100% 100%;
  cursor: pointer;
}
.menuBox {
  float: right;
  /* height: 100%;
  width: 624px; */
  margin-top: 15px;
}
.el-menu.el-menu--horizontal {
  border-bottom: solid 1px #ffffff00;
}


.el-menu-item {
  /* margin: 0 20px !important; */
  font-size: 18px !important;
}
.el-submenu:nth-child(2),
.el-submenu:nth-child(3),
.el-submenu:nth-child(4) {
  width: 120px;
}
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--horizontal .el-menu .el-submenu__title {
  width: auto;
}

.el-submenu ::v-deep.el-submenu__title {
  height: 60px;
  line-height: 60px;
  font-size: 18px !important;
}
.el-menu-demo {
  /* width: 110px;
  background: #000; */
}

.el-menu--horizontal .el-menu .el-menu-item, .el-menu--horizontal .el-menu .el-submenu__title {
  height: 45px;
  line-height: 45px;
}

</style>